export default __webpack_public_path__ + "static/media/step4-6.a04e32d8.jpg";